import { Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import { C1Text, C2Text } from "../../../common/components/text/CustomText";
import CustomIcon from "../../../common/components/image/CustomIcon";
import { CustomTable, StatusBadge } from "../../../common/components/table/CustomTable";
import UIUtil from "../../../common/utils/UIUtil";
import { Theme } from "../../../common/Theme";
import UserRoleRequestsModal from "../../user/modals/UserRoleRequestsModal";
import { useState } from "react";
import Role from "../../../common/enums/Role";
import LocalStorageKey from "../../../common/enums/LocalStorageKey";

function UserRoleDashboardCard() {
    const tableHeaders = [
        {
            key: "requestTime",
            label: "Request Time",
            render: (row) => {
                const [date, time] = row.requestTime.split(" ");
                return (
                    <div>
                        <div>{date}</div>
                        <div>{time}</div>
                    </div>
                );
            },
        },
        {
            key: "completeTime",
            label: "Complete Time",
            render: (row) => {
                const [date, time] = row.completeTime.split(" ");
                return (
                    <div>
                        <div>{date}</div>
                        <div>{time}</div>
                    </div>
                );
            },
        },
        {
            key: "status",
            label: "Status",
            render: (row) => {
                const { textColor, backgroundColor, text } = UIUtil.getRoleStatusUI(row.status);

                return (
                    <StatusBadge backgroundColor={backgroundColor} color={textColor}>
                        {text}
                    </StatusBadge>
                );
            },
        },
        {
            key: "type",
            label: "Type",
        },
        {
            key: "name",
            label: "Name",
        },
    ];

    const mockData = [
        {
            requestTime: "2025-06-29 14:30:42",
            completeTime: "-",
            status: "pending",
            type: "LG Admin",
            name: "Han",
        },
        {
            requestTime: "2025-06-29 14:30:42",
            completeTime: "-",
            status: "pending",
            type: "Franchise Admin",
            name: "Kim",
        },
        {
            requestTime: "2025-06-29 14:30:42",
            completeTime: "2025-06-29 14:30:42",
            status: "reject",
            type: "Call Center",
            name: "Nam",
        },
        {
            requestTime: "2025-06-29 14:30:42",
            completeTime: "2025-06-29 14:30:42",
            status: "reject",
            type: "LG Admin",
            name: "Park",
        },
        {
            requestTime: "2025-06-29 14:30:42",
            completeTime: "2025-06-29 14:30:42",
            status: "approve",
            type: "Franchise Admin",
            name: "Yu",
        },
        {
            requestTime: "2025-06-29 14:30:42",
            completeTime: "2025-06-29 14:30:42",
            status: "approve",
            type: "Call Center",
            name: "Gum",
        },
        {
            requestTime: "2025-06-29 14:30:42",
            completeTime: "2025-06-29 14:30:42",
            status: "approve",
            type: "Call Center",
            name: "Gum",
        },
        {
            requestTime: "2025-06-29 14:30:42",
            completeTime: "2025-06-29 14:30:42",
            status: "approve",
            type: "Call Center",
            name: "Gum",
        },
        {
            requestTime: "2025-06-29 14:30:42",
            completeTime: "2025-06-29 14:30:42",
            status: "approve",
            type: "Call Center",
            name: "Gum",
        },
        {
            requestTime: "2025-06-29 14:30:42",
            completeTime: "2025-06-29 14:30:42",
            status: "approve",
            type: "Call Center",
            name: "Gum",
        },
        {
            requestTime: "2025-06-29 14:30:42",
            completeTime: "2025-06-29 14:30:42",
            status: "approve",
            type: "Call Center",
            name: "Gum",
        },
        {
            requestTime: "2025-06-29 14:30:42",
            completeTime: "2025-06-29 14:30:42",
            status: "approve",
            type: "Call Center",
            name: "Gum",
        },
        {
            requestTime: "2025-06-29 14:30:42",
            completeTime: "2025-06-29 14:30:42",
            status: "approve",
            type: "Call Center",
            name: "Gum",
        },
        {
            requestTime: "2025-06-29 14:30:42",
            completeTime: "2025-06-29 14:30:42",
            status: "approve",
            type: "Call Center",
            name: "Gum",
        },
        {
            requestTime: "2025-06-29 14:30:42",
            completeTime: "2025-06-29 14:30:42",
            status: "approve",
            type: "Call Center",
            name: "Gum",
        },
        {
            requestTime: "2025-06-29 14:30:42",
            completeTime: "2025-06-29 14:30:42",
            status: "approve",
            type: "Call Center",
            name: "Gum",
        },
        {
            requestTime: "2025-06-29 14:30:42",
            completeTime: "2025-06-29 14:30:42",
            status: "approve",
            type: "Call Center",
            name: "Gum",
        },
        {
            requestTime: "2025-06-29 14:30:42",
            completeTime: "2025-06-29 14:30:42",
            status: "approve",
            type: "Call Center",
            name: "Gum",
        },
        {
            requestTime: "2025-06-29 14:30:42",
            completeTime: "2025-06-29 14:30:42",
            status: "approve",
            type: "Call Center",
            name: "Gum",
        },
        {
            requestTime: "2025-06-29 14:30:42",
            completeTime: "2025-06-29 14:30:42",
            status: "approve",
            type: "Call Center",
            name: "Gum",
        },
        {
            requestTime: "2025-06-29 14:30:42",
            completeTime: "2025-06-29 14:30:42",
            status: "approve",
            type: "Call Center",
            name: "Gum",
        },
    ];

    // 롤 리퀘스트 모달
    const [openRoleRequestsModal, setOpenRoleRequestsModal] = useState(false);

    // admin 권한이면 Franchise Admin 타입만 노출
    const role = localStorage.getItem(LocalStorageKey.role);
    const tableData =
        role === Role.Admin ? mockData.filter((row) => row.type === "Franchise Admin") : mockData;

    return (
        <SizedBox
            border={`1px solid ${Theme.color.gray250}`}
            borderRadius={"16px"}
            width={"100%"}
            height={"781px"}
            alignItem={"flex-start"}
            justifyContent={"flex-start"}
            padding={"16px"}
            backgroundColor={"transparent"}
        >
            <Row width={"100%"} justifyContent={"space-between"}>
                <C1Text>User Role</C1Text>
                <Row alignItme={"center"} cursor={"pointer"} onClick={() => setOpenRoleRequestsModal(true)}>
                    <C2Text fontColor={Theme.color.gray500} fontWeight={"500"} cursor={"pointer"}>
                        Role Requests
                    </C2Text>
                    <CustomIcon iconName={"chevron_right"} size={"18px"} cursor={"pointer"} />
                </Row>
            </Row>
            <SizedBox height={"20px"} />
            <CustomTable headers={tableHeaders} data={tableData} />
            {openRoleRequestsModal && (
                <UserRoleRequestsModal isOpen={openRoleRequestsModal} onClose={() => setOpenRoleRequestsModal(false)} />
            )}
        </SizedBox>
    );
}

export default UserRoleDashboardCard;
